import React, { useState } from "react";
import { AiFillHeart, AiOutlineHeart } from "react-icons/ai";
import { FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { removeFromCart, updateCart } from "../actions/cartActions";
import "../styles/cartitem.css";
import { formatMoney } from "./formatMoney";
import { isInWishlist, getWishlistItem } from "../utils/globals";
import { addToWishlist, deleteFromWishlist } from "../actions/wishlistActions";
import { fetchWishlist } from "../actions/wishlistActions";
import { toast } from "react-toastify";

const CartItem = ({ product, cartItemId, CartItem }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isRemoving, setIsRemoving] = useState(false);
  const [localQuantity, setLocalQuantity] = useState(product.quantity);
  const [itemTotal, setItemTotal] = useState(product.price * product.quantity);
  const { isAuthenticated } = useSelector((state) => state.auth);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState("");
  const [notificationAction, setNotificationAction] = useState("");

  const handleQuantityChange = (change) => {
    const newQuantity = localQuantity + change;
    if (newQuantity >= 1) {
      setLocalQuantity(newQuantity);
      setItemTotal(product.price * newQuantity);
      dispatch(
        updateCart({
          cart_item_id: cartItemId,
          product_id: product.product_id || product.productId,
          quantity: newQuantity,
          option_id: CartItem.option_id,
          size_id: CartItem.size_id,
          selected_color: CartItem.selected_color,
        }),
      );
    }
  };

  const handleBuyNow = () => {
    navigate("/checkout", {
      state: {
        singleItem: {
          product_id: product.product_id,
          quantity: localQuantity,
          price: Number(product.price),
          name: product.name,
          imageUrl: product.imageUrl,
          weight: product.weight,
        },
      },
    });
  };

  const handleRemoveClick = () => {
    setIsRemoving(true);
    dispatch(removeFromCart(cartItemId));
  };

  const handleWishlistToggle = async () => {
    if (!isAuthenticated) {
      navigate("/signin?redirect=/cart");
      return;
    }

    try {
      let result;
      if (isInWishlist(product.productId)) {
        result = await dispatch(
          deleteFromWishlist(getWishlistItem(product.productId).wishlist_id),
        );
        toast.success("Item removed from wishlist!");
        setNotificationMessage(`${product.name} removed from wishlist`);
        dispatch(fetchWishlist());
      } else {
        console.log("adding to wishlist", product);
        result = await dispatch(addToWishlist(product.productId));
        if (result.isAlreadyInWishlist) {
          setNotificationMessage(`Item is already in wishlist`);
        } else {
          setNotificationMessage(`${product.name} added to wishlist`);
          dispatch(fetchWishlist());
        }
      }

      setNotificationAction("View Wishlist");
      setShowNotification(true);
      dispatch(fetchWishlist());
    } catch (error) {
      console.error("Error toggling wishlist:", error);

      setNotificationMessage("Failed to update wishlist");
      setNotificationAction("Try Again");
      setShowNotification(true);
    }
  };

  const getImage = (image) => {
    if (CartItem.option_id && CartItem.option && CartItem.option.image) {
      return CartItem.option.image;
    }
    return image;
  };
  return (
    <div className={`cart-item ${isRemoving ? "fade-out" : ""}`}>
      <img
        src={getImage(product.imageUrl)}
        alt={product.name}
        className="cart-item-image"
      />
      <div className="cart-item-details">
        <h4 className="cart-item-name">{product.name}</h4>
        {product.size_name ? (
          <p
            className="cart-item-color"
            style={{ margin: "4px 0", fontSize: "0.9rem" }}
          >
            Size: <strong>{product.size_name}</strong>
          </p>
        ) : null}
        {product.selected_color ? (
          <p
            className="cart-item-color"
            style={{ margin: "4px 0", fontSize: "0.9rem" }}
          >
            Color: <strong>{product.selected_color}</strong>
          </p>
        ) : null}
        <div className="cart-item-description">{product.description}</div>
        <div className="cart-item-price-section">
          <span className="cart-item-price">
            {formatMoney(itemTotal)}
            {localQuantity > 1 && (
              <span className="cart-item-unit-price">
                ({formatMoney(product.price)} each)
              </span>
            )}
          </span>
          {product.discountedPrice && (
            <span className="cart-item-discounted-price">
              {formatMoney(product.discounted_price * localQuantity)}
            </span>
          )}
        </div>
        <div className="cart-item-actions">
          <div className="cart-item-quantity-controls">
            <button
              className="quantity-decrease"
              onClick={() => handleQuantityChange(-1)}
              disabled={localQuantity <= 1}
            >
              -
            </button>
            <span className="cart-item-quantity">{localQuantity}</span>
            <button
              className="quantity-increase"
              onClick={() => handleQuantityChange(1)}
            >
              +
            </button>
          </div>
          {/* <button 
            className="cart-buy-now-button"
            onClick={handleBuyNow}
          >
            Buy Now
          </button> */}
        </div>
      </div>
      <div className="cart-item-icons">
        {isInWishlist(product.productId) ? (
          <AiFillHeart
            className="icon-heart green"
            onClick={handleWishlistToggle}
          />
        ) : (
          <AiOutlineHeart
            className="icon-heart green"
            onClick={handleWishlistToggle}
          />
        )}
        <div className="cart-item-remove">
          <FaTimes
            className="cart-item-remove-icon"
            onClick={handleRemoveClick}
          />
        </div>
      </div>
    </div>
  );
};

export default CartItem;
